import { useState } from "react";
import { useGiftComplianceError } from "./useGiftComplianceError";
import { useBrowserHistory } from '@Utilities/services/hooks/useBrowserHistory';
import { logComponentEvent } from '@Utilities/services/logging/componentEvent';

export const useGiftCompliance = () => {
  const { relationshipError, updateRelationshipError, validateRelationshipForm } = useGiftComplianceError();
  const browserHistory = useBrowserHistory();
  const [relationship, setRelationship] = useState('');

  const updateRelationship = (value) => {
    logComponentEvent('GiftingRelationship', 'RelationshipSelected');
    updateRelationshipError(value);
    setRelationship(value);
  };

  const onComplianceNext = () => {
    const { isRelationshipValid } = validateRelationshipForm(relationship);
    logComponentEvent('GiftingRelationship', 'CtaClicked', { data: { relationship } });

    if (isRelationshipValid) {
      browserHistory.push('/gift/review');
    } else {
      updateRelationshipError(relationship);
    }
  };

  return {
    relationship,
    relationshipError,
    updateRelationship,
    onComplianceNext,
    validateRelationshipForm
  };
};
